import type { SVGProps } from "react";
const SvgCommunityPostTypeAnnouncement = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 15 16"
    fontSize="1rem"
    {...props}
  >
    <path
      fill="#FF7262"
      fillRule="evenodd"
      d="M11.574 3.012a.686.686 0 0 0-.177-.917.604.604 0 0 0-.866.188l-.284.455a.686.686 0 0 0 .177.917.604.604 0 0 0 .866-.188zm-.225 1.99a.684.684 0 0 1 .228-.905l.599-.366a.606.606 0 0 1 .854.243.683.683 0 0 1-.23.904l-.598.365a.606.606 0 0 1-.853-.242m-2.613 5.607 2.76-.655c.412-.098.615-.59.404-.977L8.377 2.513a.606.606 0 0 0-1.001-.118L1.7 8.92a1.88 1.88 0 0 0-.222 2.12c.365.67 1.092 1.016 1.805.865q.085.259.22.505c.776 1.424 2.496 1.912 3.841 1.09.992-.607 1.503-1.757 1.392-2.89m-1.235.294a1.68 1.68 0 0 1-.782 1.45c-.747.456-1.703.185-2.134-.606a2 2 0 0 1-.067-.136zm4.487-4.381c-.02-.365.242-.678.586-.7l.515-.033c.344-.022.64.256.66.621.022.365-.24.678-.585.7l-.515.033c-.344.022-.64-.256-.661-.621"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgCommunityPostTypeAnnouncement;
